import React, { useState, useEffect, useRef } from 'react'
import { Link, NavLink, BrowserRouter, useHistory } from 'react-router-dom';
//import { browserHistory } from 'react-router'
import CONFIG from '../../config';
import * as axios from "axios";
import { getAuthHeader } from "../../utils";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Select from "react-validation/build/select";
import CheckButton from "react-validation/build/button";
import { selectDistrict, selectState } from '../Actions/CommonAction';
import { addRecruiter, getCompanyList } from '../Actions/AdminAction';
import { token, getLogout } from '../Actions/AuthAction';
import Loader from '../Common/Loader';
import ShowError from '../Common/Error';
import { Button } from 'react-bootstrap';
import Swal from 'sweetalert2';

const ChangePassword = () => {

    const [showpassOld, setShowpassOld] = useState(false);
    const [showpass, setShowpass] = useState(false);
    const [showpassconfirm, setShowpassconfirm] = useState(false);

    const [oldpassword, setOldPassword] = useState("");
    const [givepassword, setGivePassword] = useState("");
    const [givepasswordconfirm, setGivePasswordConfirm] = useState("");



    const toggleOldPassword = () => {
        if (showpassOld == true) {
            setShowpassOld(false);
        } else {
            setShowpassOld(true);
        }
    };

    const togglePassword = () => {
        if (showpass == true) {
            setShowpass(false);
        } else {
            setShowpass(true);
        }
    };

    const togglePasswordConfirm = () => {
        if (showpassconfirm == true) {
            setShowpassconfirm(false);
        } else {
            setShowpassconfirm(true);
        }
    };

    const updatepassword = (e) => {
        e.preventDefault();
        //alert("hghgfhg");
        //return false;
        if (givepassword.length > 5) {
            if(givepassword != oldpassword){
                if (givepassword == givepasswordconfirm) {
                    var jsonToPost = {
                        "loginusertoken": token(),
                        "password": givepassword,
                        "oldpassword": oldpassword
                    }
                    changepwdAPI(jsonToPost).then((res) => {
                        if (res.status) {
                            let result = Swal.fire({
                                icon: "success",
                                title: 'Done',
                                text: 'Congratulations!',
                                footer: 'Your Password Has Been Changed Successfully.'
                            }).then(function (result) {
                                getLogout();
                            })
                        }
                        else {
                            Swal.fire({
                                icon: 'error',
                                title: 'Oops...',
                                text: 'Something went wrong!',
                                footer: res.message
                            })
                        }
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Password does not match.',
                    })
                }
            }else{
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Old and New Password match. Please enter another password.',
                })
            }
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Password should be alteast 6 characters.',
            })
        }

    }


    const changepwdAPI = (model) => {
        const url = `${CONFIG.BASE_URL}/user/changepwd`;
        return axios.post(url, model, getAuthHeader()).then((response) => {
            return response.data;
        });
    };


    return (
        <>
            <div className="row mb-4">
                <div className="col-md-12">
                    <h4 className="table_heading position-relative">CHANGE PASSWORD</h4>
                </div>
            </div>
            <div className="card formcard col-md-6">
                <div className="card-body">
                    <Form className="auth_form" onSubmit={updatepassword}>
                        <div className="row">
                            <div className="form-group col-md-12 position-relative">
                                <label className="small mb-1" for="inputPassword">Old Password</label>
                                <input type={showpassOld ? "text" : "password"} className="form-control py-4 rounded-pill" PlaceHolder="Enter Old Password" value={oldpassword} onChange={(e) => setOldPassword(e.target.value)} />
                                <buttton onClick={toggleOldPassword} className="changepwdeye">{showpassOld ? <i class="bi bi-eye"></i> : <i class="bi bi-eye-slash"></i>}</buttton>
                            </div>
                            <div className="form-group col-md-12 position-relative">
                                <label className="small mb-1" for="inputPassword">New Password</label>
                                <input type={showpass ? "text" : "password"} className="form-control py-4 rounded-pill" PlaceHolder="Enter New Password"  value={givepassword} onChange={(e) => setGivePassword(e.target.value)}/>
                                <buttton onClick={togglePassword} className="changepwdeye">{showpass ? <i class="bi bi-eye"></i> : <i class="bi bi-eye-slash"></i>}</buttton>
                            </div>
                            <div className="form-group col-md-12 position-relative">
                                <label className="small mb-1" for="inputPassword">Confirm Password</label>
                                <input type={showpassconfirm ? "text" : "password"} className="form-control py-4 rounded-pill" PlaceHolder="Confirm Password" value={givepasswordconfirm} onChange={(e) => setGivePasswordConfirm(e.target.value)} />
                                <buttton onClick={togglePasswordConfirm} className="changepwdeye">{showpassconfirm ? <i class="bi bi-eye"></i> : <i class="bi bi-eye-slash"></i>}</buttton>
                            </div>
                            <div className="form-group col-md-12">
                                <Button type='submit' className="btn btn-primary-custom">Submit</Button>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </>
    )
}

export default ChangePassword
